<template>
  <div class="emoji-picker">
    <el-popover
      placement="bottom"
      width="360"
      trigger="click"
      @show="handleShow"
      :visible-arrow="false"
      popper-class="emoji-popover"
    >
      <div class="emoji-panel">
        <div class="emoji-tabs">
          <span 
            v-for="(tab, index) in tabs" 
            :key="index"
            :class="['emoji-tab', { active: currentTab === index }]"
            @click="currentTab = index"
          >
            {{ tab }}
          </span>
        </div>
        <div class="emoji-content">
          <div class="emoji-row" v-for="(row, rowIndex) in currentEmojis" :key="rowIndex">
            <span 
              v-for="(emoji, colIndex) in row" 
              :key="colIndex"
              class="emoji-item"
              @click="selectEmoji(emoji)"
            >
              {{ emoji }}
            </span>
          </div>
        </div>
      </div>
      <el-button 
        slot="reference" 
        type="text" 
        size="mini"
        class="emoji-trigger"
      >
        <i class="el-icon-picture-outline"></i> 表情
      </el-button>
    </el-popover>
  </div>
</template>

<script>
export default {
  name: 'EmojiPicker',
  props: {
    targetInput: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      currentTab: 0,
      tabs: ['常用', '默认', '表情'],
      emojis: [
        ['😀', '😁', '😂', '🤣', '😃', '😄', '😅', '😆', '😉', '😊', '😋', '😎', '😍', '😘', '🥰', '😗', '😙', '😚', '🙂', '🤗', '🤩', '🤔', '🤨', '😐', '😑', '😶', '🙄', '😏', '😣', '😥', '😮', '🤐', '😯', '😪', '😫', '😴', '😌', '😛', '😜', '😝', '🤤', '😒', '😓', '😔', '😕', '🙃', '🤑', '😲', '☹️', '🙁', '😖', '😞', '😟', '😤', '😢', '😭', '😦', '😧', '😨', '😩', '🤯', '😬', '😰', '😱', '🥵', '🥶', '😳', '🤪', '😵', '😡', '😠', '🤬', '😷', '🤒', '🤕', '🤢', '🤮', '🤧', '😇', '🤠', '🤡', '🥳', '🥴', '🥺', '🤥', '🤫', '🤭', '🧐', '🤓', '😈', '👿', '👹', '👺', '💀', '👻', '👽', '🤖', '💩', '😺', '😸', '😹', '😻', '😼', '😽', '🙀', '😿', '😾'],
        ['❤️', '💛', '💚', '💙', '💜', '🖤', '💔', '❣️', '💕', '💞', '💓', '💗', '💖', '💘', '💝', '💟', '☮️', '✝️', '☪️', '🕉️', '☸️', '✡️', '🔯', '🕎', '☯️', '☦️', '🛐', '⛎', '♈', '♉', '♊', '♋', '♌', '♍', '♎', '♏', '♐', '♑', '♒', '♓', '🆔', '⚛️', '🉑', '☢️', '☣️', '📴', '📳', '🈶', '🈚', '🈸', '🈺', '🈷️', '✴️', '🆚', '💮', '🉐', '㊙️', '㊗️', '🈴', '🈵', '🈹', '🈲', '🅰️', '🅱️', '🆎', '🆑', '🅾️', '🆘', '❌', '⭕', '🛑', '⛔', '📛', '🚫', '💯', '💢', '♨️', '🚷', '🚯', '🚳', '🚱', '🔞', '📵', '🚭'],
        ['👋', '🤚', '🖐️', '✋', '🖖', '👌', '🤌', '🤏', '✌️', '🤞', '🤟', '🤘', '🤙', '👈', '👉', '👆', '🖕', '👇', '☝️', '👍', '👎', '✊', '👊', '🤛', '🤜', '👏', '🙌', '👐', '🤲', '🤝', '🙏', '✍️', '💅', '🤳', '💪', '🦾', '🦿', '🦵', '🦶', '👂', '🦻', '👃', '🧠', '🦷', '🦴', '👀', '👁️', '👅', '👄', '💋', '🩸', '👶', '🧒', '👦', '👧', '🧑', '👱', '👨', '🧔', '👨‍🦰', '👨‍🦱', '👨‍🦳', '👨‍🦲', '👩', '👩‍🦰', '🧑‍🦰', '👧‍🦰', '👦‍🦰', '👩‍🦱', '🧑‍🦱', '👧‍🦱', '👦‍🦱', '👩‍🦳', '🧑‍🦳', '👧‍🦳', '👦‍🦳', '👩‍🦲', '🧑‍🦲', '👧‍🦲', '👦‍🦲', '👱‍♀️', '👱‍♂️', '🧕', '👨‍⚕️', '👩‍⚕️', '👨‍🎓', '👩‍🎓', '👨‍🏫', '👩‍🏫', '👨‍⚖️', '👩‍⚖️', '👨‍🌾', '👩‍🌾', '👨‍🍳', '👩‍🍳', '👨‍🔧', '👩‍🔧', '👨‍🏭', '👩‍🏭', '👨‍💼', '👩‍💼', '👨‍🔬', '👩‍🔬', '👨‍💻', '👩‍💻', '👨‍🎤', '👩‍🎤', '👨‍🎨', '👩‍🎨', '👨‍✈️', '👩‍✈️', '👨‍🚀', '👩‍🚀', '👨‍🚒', '👩‍🚒', '👮‍♂️', '👮‍♀️', '🕵️‍♂️', '🕵️‍♀️', '💂‍♂️', '💂‍♀️', '👷‍♂️', '👷‍♀️', '🤴', '👸', '👳‍♂️', '👳‍♀️', '👲', '🧝‍♂️', '🧝‍♀️', '🧞‍♂️', '🧞‍♀️', '🧟‍♂️', '🧟‍♀️']
      ]
    }
  },
  computed: {
    currentEmojis() {
      const emojiArray = this.emojis[this.currentTab] || this.emojis[0]
      const rows = []
      for (let i = 0; i < emojiArray.length; i += 8) {
        rows.push(emojiArray.slice(i, i + 8))
      }
      return rows
    }
  },
  methods: {
    selectEmoji(emoji) {
      this.$emit('select', emoji)
    },
    handleShow() {
      this.currentTab = 0
    }
  }
}
</script>

<style scoped lang="less">
.emoji-picker {
  display: inline-block;
  margin-left: 8px;
  
  .emoji-trigger {
    color: #667eea;
    font-size: 14px;
    padding: 6px 12px;
    border: 1px solid #667eea;
    border-radius: 4px;
    
    &:hover {
      background: rgba(102, 126, 234, 0.1);
    }
  }
}
</style>

<style lang="less">
.emoji-popover {
  padding: 0 !important;
  border-radius: 12px !important;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.15) !important;
  z-index: 9999 !important;
  
  .emoji-panel {
    padding: 16px;
    background: #fff;
  }
  
  .emoji-tabs {
    display: flex;
    border-bottom: 2px solid #f0f0f0;
    margin-bottom: 16px;
    
    .emoji-tab {
      flex: 1;
      text-align: center;
      padding: 10px;
      font-size: 15px;
      color: #666;
      cursor: pointer;
      transition: all 0.2s;
      border-bottom: 2px solid transparent;
      margin-bottom: -2px;
      
      &:hover {
        color: #667eea;
        background: rgba(102, 126, 234, 0.05);
      }
      
      &.active {
        color: #667eea;
        border-bottom-color: #667eea;
        font-weight: 600;
      }
    }
  }
  
  .emoji-content {
    max-height: 360px;
    overflow-y: auto;
    
    &::-webkit-scrollbar {
      width: 8px;
    }
    
    &::-webkit-scrollbar-thumb {
      background: #ddd;
      border-radius: 4px;
      
      &:hover {
        background: #ccc;
      }
    }
  }
  
  .emoji-row {
    display: flex;
    flex-wrap: wrap;
    margin-bottom: 8px;
    
    .emoji-item {
      width: 12.5%;
      height: 48px;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 32px;
      cursor: pointer;
      border-radius: 6px;
      transition: all 0.2s;
      
      &:hover {
        background: rgba(102, 126, 234, 0.1);
        transform: scale(1.3);
      }
      
      &:active {
        transform: scale(0.95);
      }
    }
  }
}
</style>
